(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === "object" && typeof module === "object")
    module.exports = factory();
  else if (typeof define === "function" && define.amd) define([], factory);
  else if (typeof exports === "object") exports["BeerSlider"] = factory();
  else root["BeerSlider"] = factory();
})(window, function () {
  return /******/ (function (modules) {
    // webpackBootstrap
    /******/ // The module cache
    /******/ var installedModules = {};
    /******/
    /******/ // The require function
    /******/ function __webpack_require__(moduleId) {
      /******/
      /******/ // Check if module is in cache
      /******/ if (installedModules[moduleId]) {
        /******/ return installedModules[moduleId].exports;
        /******/
      }
      /******/ // Create a new module (and put it into the cache)
      /******/ var module = (installedModules[moduleId] = {
        /******/ i: moduleId,
        /******/ l: false,
        /******/ exports: {},
        /******/
      });
      /******/
      /******/ // Execute the module function
      /******/ modules[moduleId].call(
        module.exports,
        module,
        module.exports,
        __webpack_require__
      );
      /******/
      /******/ // Flag the module as loaded
      /******/ module.l = true;
      /******/
      /******/ // Return the exports of the module
      /******/ return module.exports;
      /******/
    }
    /******/
    /******/
    /******/ // expose the modules object (__webpack_modules__)
    /******/ __webpack_require__.m = modules;
    /******/
    /******/ // expose the module cache
    /******/ __webpack_require__.c = installedModules;
    /******/
    /******/ // define getter function for harmony exports
    /******/ __webpack_require__.d = function (exports, name, getter) {
      /******/ if (!__webpack_require__.o(exports, name)) {
        /******/ Object.defineProperty(exports, name, {
          enumerable: true,
          get: getter,
        });
        /******/
      }
      /******/
    };
    /******/
    /******/ // define __esModule on exports
    /******/ __webpack_require__.r = function (exports) {
      /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
        /******/ Object.defineProperty(exports, Symbol.toStringTag, {
          value: "Module",
        });
        /******/
      }
      /******/ Object.defineProperty(exports, "__esModule", { value: true });
      /******/
    };
    /******/
    /******/ // create a fake namespace object
    /******/ // mode & 1: value is a module id, require it
    /******/ // mode & 2: merge all properties of value into the ns
    /******/ // mode & 4: return value when already ns object
    /******/ // mode & 8|1: behave like require
    /******/ __webpack_require__.t = function (value, mode) {
      /******/ if (mode & 1) value = __webpack_require__(value);
      /******/ if (mode & 8) return value;
      /******/ if (
        mode & 4 &&
        typeof value === "object" &&
        value &&
        value.__esModule
      )
        return value;
      /******/ var ns = Object.create(null);
      /******/ __webpack_require__.r(ns);
      /******/ Object.defineProperty(ns, "default", {
        enumerable: true,
        value: value,
      });
      /******/ if (mode & 2 && typeof value != "string")
        for (var key in value)
          __webpack_require__.d(
            ns,
            key,
            function (key) {
              return value[key];
            }.bind(null, key)
          );
      /******/ return ns;
      /******/
    };
    /******/
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/ __webpack_require__.n = function (module) {
      /******/ var getter =
        module && module.__esModule
          ? /******/ function getDefault() {
              return module["default"];
            }
          : /******/ function getModuleExports() {
              return module;
            };
      /******/ __webpack_require__.d(getter, "a", getter);
      /******/ return getter;
      /******/
    };
    /******/
    /******/ // Object.prototype.hasOwnProperty.call
    /******/ __webpack_require__.o = function (object, property) {
      return Object.prototype.hasOwnProperty.call(object, property);
    };
    /******/
    /******/ // __webpack_public_path__
    /******/ __webpack_require__.p = "";
    /******/
    /******/
    /******/ // Load entry module and return exports
    /******/ return __webpack_require__((__webpack_require__.s = 47));
    /******/
  })(
    /************************************************************************/
    /******/ [
      /* 0 */
      /***/ function (module, exports) {
        // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
        module.exports =
          typeof window != "undefined" && window.Math == Math
            ? window
            : typeof self != "undefined" && self.Math == Math
            ? self
            : // eslint-disable-next-line no-new-func
              Function("return this")();

        /***/
      },
      /* 1 */
      /***/ function (module, exports, __webpack_require__) {
        var store = __webpack_require__(11)("wks");
        var uid = __webpack_require__(33);
        var Symbol = __webpack_require__(0).Symbol;
        var USE_SYMBOL = __webpack_require__(54);

        module.exports = function (name) {
          return (
            store[name] ||
            (store[name] =
              (USE_SYMBOL && Symbol[name]) ||
              (USE_SYMBOL ? Symbol : uid)("Symbol." + name))
          );
        };

        /***/
      },
      /* 2 */
      /***/ function (module, exports, __webpack_require__) {
        var isObject = __webpack_require__(5);

        module.exports = function (it) {
          if (!isObject(it)) throw TypeError(String(it) + " is not an object!");
          return it;
        };

        /***/
      },
      /* 3 */
      /***/ function (module, exports, __webpack_require__) {
        var definePropertyModule = __webpack_require__(8);
        var createPropertyDescriptor = __webpack_require__(21);

        module.exports = __webpack_require__(6)
          ? function (object, key, value) {
              return definePropertyModule.f(
                object,
                key,
                createPropertyDescriptor(1, value)
              );
            }
          : function (object, key, value) {
              object[key] = value;
              return object;
            };

        /***/
      },
      /* 4 */
      /***/ function (module, exports) {
        var hasOwnProperty = {}.hasOwnProperty;

        module.exports = function (it, key) {
          return hasOwnProperty.call(it, key);
        };

        /***/
      },
      /* 5 */
      /***/ function (module, exports) {
        module.exports = function (it) {
          return typeof it === "object"
            ? it !== null
            : typeof it === "function";
        };

        /***/
      },
      /* 6 */
      /***/ function (module, exports, __webpack_require__) {
        // Thank's IE8 for his funny defineProperty
        module.exports = !__webpack_require__(12)(function () {
          return (
            Object.defineProperty({}, "a", {
              get: function () {
                return 7;
              },
            }).a != 7
          );
        });

        /***/
      },
      /* 7 */
      /***/ function (module, exports) {
        var toString = {}.toString;

        module.exports = function (it) {
          return toString.call(it).slice(8, -1);
        };

        /***/
      },
      /* 8 */
      /***/ function (module, exports, __webpack_require__) {
        var DESCRIPTORS = __webpack_require__(6);
        var IE8_DOM_DEFINE = __webpack_require__(31);
        var anObject = __webpack_require__(2);
        var toPrimitive = __webpack_require__(32);
        var nativeDefineProperty = Object.defineProperty;

        exports.f = DESCRIPTORS
          ? nativeDefineProperty
          : function defineProperty(O, P, Attributes) {
              anObject(O);
              P = toPrimitive(P, true);
              anObject(Attributes);
              if (IE8_DOM_DEFINE)
                try {
                  return nativeDefineProperty(O, P, Attributes);
                } catch (e) {
                  /* empty */
                }
              if ("get" in Attributes || "set" in Attributes)
                throw TypeError("Accessors not supported!");
              if ("value" in Attributes) O[P] = Attributes.value;
              return O;
            };

        /***/
      },
      /* 9 */
      /***/ function (module, exports, __webpack_require__) {
        var global = __webpack_require__(0);
        var hide = __webpack_require__(3);
        var redefine = __webpack_require__(14);
        var setGlobal = __webpack_require__(19);
        var copyConstructorProperties = __webpack_require__(57);

        /*
  options.target - name of the target object
  options.global - target is the global object
  options.stat   - export as static methods of target
  options.proto  - export as prototype methods of target
  options.real   - real prototype method for the `pure` version
  options.forced - export even if the native feature is available
  options.bind   - bind methods to the target, required for the `pure` version
  options.wrap   - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe - use the simple assignment of property instead of delete + defineProperty
  options.sham   - add a flag to not completely full polyfills
*/
        module.exports = function (options, source) {
          var TARGET = options.target;
          var target, key, targetProperty, sourceProperty;
          if (options.global) {
            target = global;
          } else if (options.stat) {
            target = global[TARGET] || setGlobal(TARGET, {});
          } else {
            target = (global[TARGET] || {}).prototype;
          }
          if (target)
            for (key in source) {
              targetProperty = target[key];
              sourceProperty = source[key];
              // contained in target
              if (!options.forced && targetProperty !== undefined) {
                if (typeof sourceProperty === typeof targetProperty) continue;
                copyConstructorProperties(sourceProperty, targetProperty);
              }
              // add a flag to not completely full polyfills
              if (options.sham || (targetProperty && targetProperty.sham)) {
                hide(sourceProperty, "sham", true);
              }
              // extend global
              redefine(target, key, sourceProperty, options.unsafe);
            }
        };

        /***/
      },
      /* 10 */
      /***/ function (module, exports) {
        module.exports = {};

        /***/
      },
      /* 11 */
      /***/ function (module, exports, __webpack_require__) {
        var global = __webpack_require__(0);
        var setGlobal = __webpack_require__(19);
        var SHARED = "__core-js_shared__";
        var store = global[SHARED] || setGlobal(SHARED, {});

        (module.exports = function (key, value) {
          return store[key] || (store[key] = value !== undefined ? value : {});
        })("versions", []).push({
          version: "3.0.0-beta.3",
          mode: __webpack_require__(13) ? "pure" : "global",
          copyright: "© 2018 Denis Pushkarev (zloirock.ru)",
        });

        /***/
      },
      /* 12 */
      /***/ function (module, exports) {
        module.exports = function (exec) {
          try {
            return !!exec();
          } catch (e) {
            return true;
          }
        };

        /***/
      },
      /* 13 */
      /***/ function (module, exports) {
        module.exports = false;

        /***/
      },
      /* 14 */
      /***/ function (module, exports, __webpack_require__) {
        var global = __webpack_require__(0);
        var hide = __webpack_require__(3);
        var has = __webpack_require__(4);
        var setGlobal = __webpack_require__(19);
        var nativeFunctionToString = __webpack_require__(34);
        var InternalStateModule = __webpack_require__(15);
        var getInternalState = InternalStateModule.get;
        var enforceInternalState = InternalStateModule.enforce;
        var TEMPLATE = String(nativeFunctionToString).split("toString");

        __webpack_require__(11)("inspectSource", function (it) {
          return nativeFunctionToString.call(it);
        });

        (module.exports = function (O, key, value, unsafe) {
          if (typeof value == "function") {
            if (typeof key == "string" && !has(value, "name"))
              hide(value, "name", key);
            enforceInternalState(value).source = TEMPLATE.join(
              typeof key == "string" ? key : ""
            );
          }
          if (O === global) {
            setGlobal(key, value);
          } else if (!unsafe) {
            delete O[key];
            hide(O, key, value);
          } else if (O[key]) {
            O[key] = value;
          } else {
            hide(O, key, value);
          }
          // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
        })(Function.prototype, "toString", function toString() {
          return (
            (typeof this == "function" && getInternalState(this).source) ||
            nativeFunctionToString.call(this)
          );
        });

        /***/
      },
      /* 15 */
      /***/ function (module, exports, __webpack_require__) {
        var global = __webpack_require__(0);
        var nativeFunctionToString = __webpack_require__(34);
        var isObject = __webpack_require__(5);
        var hide = __webpack_require__(3);
        var objectHas = __webpack_require__(4);
        var sharedKey = __webpack_require__(22);
        var hiddenKeys = __webpack_require__(23);
        var WeakMap = global.WeakMap;
        var set, get, has;

        var enforce = function (it) {
          return has(it) ? get(it) : set(it, {});
        };

        var getterFor = function (TYPE) {
          return function (it) {
            var state;
            if (!isObject(it) || (state = get(it)).type !== TYPE) {
              throw TypeError("Incompatible receiver, " + TYPE + " required!");
            }
            return state;
          };
        };

        if (
          typeof WeakMap == "function" &&
          /native code/.test(nativeFunctionToString.call(WeakMap))
        ) {
          var store = new WeakMap();
          var wmget = store.get;
          var wmhas = store.has;
          var wmset = store.set;
          set = function (it, metadata) {
            wmset.call(store, it, metadata);
            return metadata;
          };
          get = function (it) {
            return wmget.call(store, it) || {};
          };
          has = function (it) {
            return wmhas.call(store, it);
          };
        } else {
          var STATE = sharedKey("state");
          hiddenKeys[STATE] = true;
          set = function (it, metadata) {
            hide(it, STATE, metadata);
            return metadata;
          };
          get = function (it) {
            return objectHas(it, STATE) ? it[STATE] : {};
          };
          has = function (it) {
            return objectHas(it, STATE);
          };
        }

        module.exports = {
          set: set,
          get: get,
          has: has,
          enforce: enforce,
          getterFor: getterFor,
        };

        /***/
      },
      /* 16 */
      /***/ function (module, exports, __webpack_require__) {
        // toObject with fallback for non-array-like ES3 strings
        var IndexedObject = __webpack_require__(60);
        var requireObjectCoercible = __webpack_require__(25);

        module.exports = function (it) {
          return IndexedObject(requireObjectCoercible(it));
        };

        /***/
      },
      /* 17 */
      /***/ function (module, exports) {
        module.exports = function (it) {
          if (typeof it != "function")
            throw TypeError(String(it) + " is not a function!");
          return it;
        };

        /***/
      },
      /* 18 */
      /***/ function (module, exports, __webpack_require__) {
        "use strict";

        // 25.4.1.5 NewPromiseCapability(C)
        var aFunction = __webpack_require__(17);

        var PromiseCapability = function (C) {
          var resolve, reject;
          this.promise = new C(function ($$resolve, $$reject) {
            if (resolve !== undefined || reject !== undefined)
              throw TypeError("Bad Promise constructor");
            resolve = $$resolve;
            reject = $$reject;
          });
          this.resolve = aFunction(resolve);
          this.reject = aFunction(reject);
        };

        module.exports.f = function (C) {
          return new PromiseCapability(C);
        };

        /***/
      },
      /* 19 */
      /***/ function (module, exports, __webpack_require__) {
        var global = __webpack_require__(0);
        var hide = __webpack_require__(3);

        module.exports = function (key, value) {
          try {
            hide(global, key, value);
          } catch (e) {
            global[key] = value;
          }
          return value;
        };

        /***/
      },
      /* 20 */
      /***/ function (module, exports, __webpack_require__) {
        var isObject = __webpack_require__(5);
        var document = __webpack_require__(0).document;
        // typeof document.createElement is 'object' in old IE
        var exist = isObject(document) && isObject(document.createElement);

        module.exports = function (it) {
          return exist ? document.createElement(it) : {};
        };

        /***/
      },
      /* 21 */
      /***/ function (module, exports) {
        module.exports = function (bitmap, value) {
          return {
            enumerable: !(bitmap & 1),
            configurable: !(bitmap & 2),
            writable: !(bitmap & 4),
            value: value,
          };
        };

        /***/
      },
      /* 22 */
      /***/ function (module, exports, __webpack_require__) {
        var shared = __webpack_require__(11)("keys");
        var uid = __webpack_require__(33);

        module.exports = function (key) {
          return shared[key] || (shared[key] = uid(key));
        };

        /***/
      },
      /* 23 */
      /***/ function (module, exports) {
        module.exports = {};

        /***/
      },
      /* 24 */
      /***/ function (module, exports) {
        var ceil = Math.ceil;
        var floor = Math.floor;

        // `ToInteger` abstract operation
        // https://tc39.github.io/ecma262/#sec-tointeger
        module.exports = function (argument) {
          return isNaN((argument = +argument))
            ? 0
            : (argument > 0 ? floor : ceil)(argument);
        };

        /***/
      },
      /* 25 */
      /***/ function (module, exports) {
        // `RequireObjectCoercible` abstract operation
        // https://tc39.github.io/ecma262/#sec-requireobjectcoercible
        module.exports = function (it) {
          if (it == undefined) throw TypeError("Can't call method on  " + it);
          return it;
        };

        /***/
      },
      /* 26 */
      /***/ function (module, exports) {
        // IE8- don't enum bug keys
        module.exports = [
          "constructor",
          "hasOwnProperty",
          "isPrototypeOf",
          "propertyIsEnumerable",
          "toLocaleString",
          "toString",
          "valueOf",
        ];

        /***/
      },
      /* 27 */
      /***/ function (module, exports, __webpack_require__) {
        var defineProperty = __webpack_require__(8).f;
        var has = __webpack_require__(4);
        var TO_STRING_TAG = __webpack_require__(1)("toStringTag");

        module.exports = function (it, TAG, STATIC) {
          if (it && !has((it = STATIC ? it : it.prototype), TO_STRING_TAG)) {
            defineProperty(it, TO_STRING_TAG, {
              configurable: true,
              value: TAG,
            });
          }
        };

        /***/
      },
      /* 28 */
      /***/ function (module, exports) {
        module.exports = function (exec) {
          try {
            return { e: false, v: exec() };
          } catch (e) {
            return { e: true, v: e };
          }
        };

        /***/
      },
      /* 29 */
      /***/ function (module, exports, __webpack_require__) {
        module.exports = __webpack_require__(0);

        /***/
      },
      /* 30 */
      /***/ function (module, exports, __webpack_require__) {
        var classofRaw = __webpack_require__(7);
        var TO_STRING_TAG = __webpack_require__(1)("toStringTag");
        // ES3 wrong here
        var CORRECT_ARGUMENTS =
          classofRaw(
            (function () {
              return arguments;
            })()
          ) == "Arguments";

        // fallback for IE11 Script Access Denied error
        var tryGet = function (it, key) {
          try {
            return it[key];
          } catch (e) {
            /* empty */
          }
        };

        // getting tag from ES6+ `Object.prototype.toString`
        module.exports = function (it) {
          var O, tag, result;
          return it === undefined
            ? "Undefined"
            : it === null
            ? "Null"
            : // @@toStringTag case
            typeof (tag = tryGet((O = Object(it)), TO_STRING_TAG)) == "string"
            ? tag
            : // builtinTag case
            CORRECT_ARGUMENTS
            ? classofRaw(O)
            : // ES3 arguments fallback
            (result = classofRaw(O)) == "Object" &&
              typeof O.callee == "function"
            ? "Arguments"
            : result;
        };

        /***/
      },
      /* 31 */
      /***/ function (module, exports, __webpack_require__) {
        // Thank's IE8 for his funny defineProperty
        module.exports =
          !__webpack_require__(6) &&
          !__webpack_require__(12)(function () {
            return (
              Object.defineProperty(__webpack_require__(20)("div"), "a", {
                get: function () {
                  return 7;
                },
              }).a != 7
            );
          });

        /***/
      },
      /* 32 */
      /***/ function (module, exports, __webpack_require__) {
        // 7.1.1 ToPrimitive(input [, PreferredType])
        var isObject = __webpack_require__(5);
        // instead of the ES6 spec version, we didn't implement @@toPrimitive case
        // and the second argument - flag - preferred type is a string
        module.exports = function (it, S) {
          if (!isObject(it)) return it;
          var fn, val;
          if (
            S &&
            typeof (fn = it.toString) == "function" &&
            !isObject((val = fn.call(it)))
          )
            return val;
          if (
            typeof (fn = it.valueOf) == "function" &&
            !isObject((val = fn.call(it)))
          )
            return val;
          if (
            !S &&
            typeof (fn = it.toString) == "function" &&
            !isObject((val = fn.call(it)))
          )
            return val;
          throw TypeError("Can't convert object to primitive value");
        };

        /***/
      },
      /* 33 */
      /***/ function (module, exports) {
        var id = 0;
        var postfix = Math.random();

        module.exports = function (key) {
          return "Symbol(".concat(
            key === undefined ? "" : key,
            ")_",
            (++id + postfix).toString(36)
          );
        };

        /***/
      },
      /* 34 */
      /***/ function (module, exports, __webpack_require__) {
        module.exports = __webpack_require__(11)(
          "native-function-to-string",
          Function.toString
        );

        /***/
      },
      /* 35 */
      /***/ function (module, exports, __webpack_require__) {
        "use strict";

        var $export = __webpack_require__(9);
        var createIteratorConstructor = __webpack_require__(66);
        var getPrototypeOf = __webpack_require__(39);
        var setPrototypeOf = __webpack_require__(71);
        var setToStringTag = __webpack_require__(27);
        var hide = __webpack_require__(3);
        var redefine = __webpack_require__(14);
        var IS_PURE = __webpack_require__(13);
        var ITERATOR = __webpack_require__(1)("iterator");
        var Iterators = __webpack_require__(10);
        var IteratorsCore = __webpack_require__(38);
        var IteratorPrototype = IteratorsCore.IteratorPrototype;
        var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
        var KEYS = "keys";
        var VALUES = "values";
        var ENTRIES = "entries";

        var returnThis = function () {
          return this;
        };

        module.exports = function (
          Iterable,
          NAME,
          IteratorConstructor,
          next,
          DEFAULT,
          IS_SET,
          FORCED
        ) {
          createIteratorConstructor(IteratorConstructor, NAME, next);

          var getIterationMethod = function (KIND) {
            if (KIND === DEFAULT && defaultIterator) return defaultIterator;
            if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype)
              return IterablePrototype[KIND];
            switch (KIND) {
              case KEYS:
                return function keys() {
                  return new IteratorConstructor(this, KIND);
                };
              case VALUES:
                return function values() {
                  return new IteratorConstructor(this, KIND);
                };
              case ENTRIES:
                return function entries() {
                  return new IteratorConstructor(this, KIND);
                };
            }
            return function () {
              return new IteratorConstructor(this);
            };
          };

          var TO_STRING_TAG = NAME + " Iterator";
          var INCORRECT_VALUES_NAME = false;
          var IterablePrototype = Iterable.prototype;
          var nativeIterator =
            IterablePrototype[ITERATOR] ||
            IterablePrototype["@@iterator"] ||
            (DEFAULT && IterablePrototype[DEFAULT]);
          var defaultIterator =
            (!BUGGY_SAFARI_ITERATORS && nativeIterator) ||
            getIterationMethod(DEFAULT);
          var anyNativeIterator =
            NAME == "Array"
              ? IterablePrototype.entries || nativeIterator
              : nativeIterator;
          var CurrentIteratorPrototype, methods, KEY;

          // fix native
          if (anyNativeIterator) {
            CurrentIteratorPrototype = getPrototypeOf(
              anyNativeIterator.call(new Iterable())
            );
            if (
              IteratorPrototype !== Object.prototype &&
              CurrentIteratorPrototype.next
            ) {
              if (
                !IS_PURE &&
                getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype
              ) {
                if (setPrototypeOf) {
                  setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
                } else if (
                  typeof CurrentIteratorPrototype[ITERATOR] != "function"
                ) {
                  hide(CurrentIteratorPrototype, ITERATOR, returnThis);
                }
              }
              // Set @@toStringTag to native iterators
              setToStringTag(
                CurrentIteratorPrototype,
                TO_STRING_TAG,
                true,
                true
              );
              if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
            }
          }

          // fix Array#{values, @@iterator}.name in V8 / FF
          if (
            DEFAULT == VALUES &&
            nativeIterator &&
            nativeIterator.name !== VALUES
          ) {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
              return nativeIterator.call(this);
            };
          }

          // define iterator
          if (
            (!IS_PURE || FORCED) &&
            IterablePrototype[ITERATOR] !== defaultIterator
          ) {
            hide(IterablePrototype, ITERATOR, defaultIterator);
          }
          Iterators[NAME] = defaultIterator;

          // export additional methods
          if (DEFAULT) {
            methods = {
              values: getIterationMethod(VALUES),
              keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
              entries: getIterationMethod(ENTRIES),
            };
            if (FORCED)
              for (KEY in methods) {
                if (
                  BUGGY_SAFARI_ITERATORS ||
                  INCORRECT_VALUES_NAME ||
                  !(KEY in IterablePrototype)
                ) {
                  redefine(IterablePrototype, KEY, methods[KEY]);
                }
              }
            else
              $export(
                {
                  target: NAME,
                  proto: true,
                  forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME,
                },
                methods
              );
          }

          return methods;
        };

        /***/
      },
      /* 36 */
      /***/ function (module, exports, __webpack_require__) {
        var has = __webpack_require__(4);
        var toIndexedObject = __webpack_require__(16);
        var arrayIndexOf = __webpack_require__(61)(false);
        var hiddenKeys = __webpack_require__(23);

        module.exports = function (object, names) {
          var O = toIndexedObject(object);
          var i = 0;
          var result = [];
          var key;
          for (key in O)
            !has(hiddenKeys, key) && has(O, key) && result.push(key);
          // Don't enum bug & hidden keys
          while (names.length > i)
            if (has(O, (key = names[i++]))) {
              ~arrayIndexOf(result, key) || result.push(key);
            }
          return result;
        };

        /***/
      },
      /* 37 */
      /***/ function (module, exports, __webpack_require__) {
        var toInteger = __webpack_require__(24);
        var min = Math.min;

        // `ToLength` abstract operation
        // https://tc39.github.io/ecma262/#sec-tolength
        module.exports = function (argument) {
          return argument > 0 ? min(toInteger(argument), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
        };

        /***/
      },
      /* 38 */
      /***/ function (module, exports, __webpack_require__) {
        "use strict";

        var getPrototypeOf = __webpack_require__(39);
        var hide = __webpack_require__(3);
        var has = __webpack_require__(4);
        var IS_PURE = __webpack_require__(13);
        var ITERATOR = __webpack_require__(1)("iterator");
        var BUGGY_SAFARI_ITERATORS = false;

        var returnThis = function () {
          return this;
        };

        // `%IteratorPrototype%` object
        // https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
        var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

        if ([].keys) {
          arrayIterator = [].keys();
          // Safari 8 has buggy iterators w/o `next`
          if (!("next" in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
          else {
            PrototypeOfArrayIteratorPrototype = getPrototypeOf(
              getPrototypeOf(arrayIterator)
            );
            if (PrototypeOfArrayIteratorPrototype !== Object.prototype)
              IteratorPrototype = PrototypeOfArrayIteratorPrototype;
          }
        }

        if (IteratorPrototype == undefined) IteratorPrototype = {};

        // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
        if (!IS_PURE && !has(IteratorPrototype, ITERATOR))
          hide(IteratorPrototype, ITERATOR, returnThis);

        module.exports = {
          IteratorPrototype: IteratorPrototype,
          BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS,
        };

        /***/
      },
      /* 39 */
      /***/ function (module, exports, __webpack_require__) {
        // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
        var has = __webpack_require__(4);
        var toObject = __webpack_require__(67);
        var IE_PROTO = __webpack_require__(22)("IE_PROTO");
        var CORRECT_PROTOTYPE_GETTER = __webpack_require__(68);
        var ObjectPrototype = Object.prototype;

        module.exports = CORRECT_PROTOTYPE_GETTER
          ? Object.getPrototypeOf
          : function (O) {
              O = toObject(O);
              if (has(O, IE_PROTO)) return O[IE_PROTO];
              if (
                typeof O.constructor == "function" &&
                O instanceof O.constructor
              ) {
                return O.constructor.prototype;
              }
              return O instanceof Object ? ObjectPrototype : null;
            };

        /***/
      },
      /* 40 */
      /***/ function (module, exports, __webpack_require__) {
        // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
        var anObject = __webpack_require__(2);
        var defineProperties = __webpack_require__(69);
        var enumBugKeys = __webpack_require__(26);
        var html = __webpack_require__(41);
        var documentCreateElement = __webpack_require__(20);
        var IE_PROTO = __webpack_require__(22)("IE_PROTO");
        var PROTOTYPE = "prototype";
        var Empty = function () {
          /* empty */
        };

        // Create object with fake `null` prototype: use iframe Object with cleared prototype
        var createDict = function () {
          // Thrash, waste and sodomy: IE GC bug
          var iframe = documentCreateElement("iframe");
          var length = enumBugKeys.length;
          var lt = "<";
          var gt = ">";
          var iframeDocument;
          iframe.style.display = "none";
          html.appendChild(iframe);
          iframe.src = "javascript:"; // eslint-disable-line no-script-url
          iframeDocument = iframe.contentWindow.document;
          iframeDocument.open();
          iframeDocument.write(
            lt + "script" + gt + "document.F=Object" + lt + "/script" + gt
          );
          iframeDocument.close();
          createDict = iframeDocument.F;
          while (length--) delete createDict[PROTOTYPE][enumBugKeys[length]];
          return createDict();
        };

        module.exports =
          Object.create ||
          function create(O, Properties) {
            var result;
            if (O !== null) {
              Empty[PROTOTYPE] = anObject(O);
              result = new Empty();
              Empty[PROTOTYPE] = null;
              // add "__proto__" for Object.getPrototypeOf polyfill
              result[IE_PROTO] = O;
            } else result = createDict();
            return Properties === undefined
              ? result
              : defineProperties(result, Properties);
          };

        __webpack_require__(23)[IE_PROTO] = true;

        /***/
      },
      /* 41 */
      /***/ function (module, exports, __webpack_require__) {
        var document = __webpack_require__(0).document;

        module.exports = document && document.documentElement;

        /***/
      },
      /* 42 */
      /***/ function (module, exports, __webpack_require__) {
        var anObject = __webpack_require__(2);
        var isArrayIteratorMethod = __webpack_require__(79);
        var toLength = __webpack_require__(37);
        var bind = __webpack_require__(43);
        var getIteratorMethod = __webpack_require__(80);
        var callWithSafeIterationClosing = __webpack_require__(81);
        var BREAK = {};

        var exports = (module.exports = function (
          iterable,
          fn,
          that,
          ENTRIES,
          ITERATOR
        ) {
          var boundFunction = bind(fn, that, ENTRIES ? 2 : 1);
          var iterator, iterFn, index, length, result, step;

          if (ITERATOR) {
            iterator = iterable;
          } else {
            iterFn = getIteratorMethod(iterable);
            if (typeof iterFn != "function")
              throw TypeError("Target is not iterable!");
            // optimisation for array iterators
            if (isArrayIteratorMethod(iterFn)) {
              for (
                index = 0, length = toLength(iterable.length);
                length > index;
                index++
              ) {
                result = ENTRIES
                  ? boundFunction(
                      anObject((step = iterable[index]))[0],
                      step[1]
                    )
                  : boundFunction(iterable[index]);
                if (result === BREAK) return;
              }
              return;
            }
            iterator = iterFn.call(iterable);
          }

          while (!(step = iterator.next()).done) {
            if (
              callWithSafeIterationClosing(
                iterator,
                boundFunction,
                step.value,
                ENTRIES
              ) === BREAK
            )
              return;
          }
        });

        exports.BREAK = BREAK;

        /***/
      },
      /* 43 */
      /***/ function (module, exports, __webpack_require__) {
        var aFunction = __webpack_require__(17);

        // optional / simple context binding
        module.exports = function (fn, that, length) {
          aFunction(fn);
          if (that === undefined) return fn;
          switch (length) {
            case 0:
              return function () {
                return fn.call(that);
              };
            case 1:
              return function (a) {
                return fn.call(that, a);
              };
            case 2:
              return function (a, b) {
                return fn.call(that, a, b);
              };
            case 3:
              return function (a, b, c) {
                return fn.call(that, a, b, c);
              };
          }
          return function (/* ...args */) {
            return fn.apply(that, arguments);
          };
        };

        /***/
      },
      /* 44 */
      /***/ function (module, exports, __webpack_require__) {
        var anObject = __webpack_require__(2);
        var aFunction = __webpack_require__(17);
        var SPECIES = __webpack_require__(1)("species");

        // `SpeciesConstructor` abstract operation
        // https://tc39.github.io/ecma262/#sec-speciesconstructor
        module.exports = function (O, defaultConstructor) {
          var C = anObject(O).constructor;
          var S;
          return C === undefined || (S = anObject(C)[SPECIES]) == undefined
            ? defaultConstructor
            : aFunction(S);
        };

        /***/
      },
      /* 45 */
      /***/ function (module, exports, __webpack_require__) {
        var global = __webpack_require__(0);
        var classof = __webpack_require__(7);
        var bind = __webpack_require__(43);
        var html = __webpack_require__(41);
        var createElement = __webpack_require__(20);
        var set = global.setImmediate;
        var clear = global.clearImmediate;
        var process = global.process;
        var MessageChannel = global.MessageChannel;
        var Dispatch = global.Dispatch;
        var counter = 0;
        var queue = {};
        var ONREADYSTATECHANGE = "onreadystatechange";
        var defer, channel, port;

        var run = function () {
          var id = +this;
          // eslint-disable-next-line no-prototype-builtins
          if (queue.hasOwnProperty(id)) {
            var fn = queue[id];
            delete queue[id];
            fn();
          }
        };

        var listener = function (event) {
          run.call(event.data);
        };

        // Node.js 0.9+ & IE10+ has setImmediate, otherwise:
        if (!set || !clear) {
          set = function setImmediate(fn) {
            var args = [];
            var i = 1;
            while (arguments.length > i) args.push(arguments[i++]);
            queue[++counter] = function () {
              // eslint-disable-next-line no-new-func
              (typeof fn == "function" ? fn : Function(fn)).apply(
                undefined,
                args
              );
            };
            defer(counter);
            return counter;
          };
          clear = function clearImmediate(id) {
            delete queue[id];
          };
          // Node.js 0.8-
          if (classof(process) == "process") {
            defer = function (id) {
              process.nextTick(bind(run, id, 1));
            };
            // Sphere (JS game engine) Dispatch API
          } else if (Dispatch && Dispatch.now) {
            defer = function (id) {
              Dispatch.now(bind(run, id, 1));
            };
            // Browsers with MessageChannel, includes WebWorkers
          } else if (MessageChannel) {
            channel = new MessageChannel();
            port = channel.port2;
            channel.port1.onmessage = listener;
            defer = bind(port.postMessage, port, 1);
            // Browsers with postMessage, skip WebWorkers
            // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
          } else if (
            global.addEventListener &&
            typeof postMessage == "function" &&
            !global.importScripts
          ) {
            defer = function (id) {
              global.postMessage(id + "", "*");
            };
            global.addEventListener("message", listener, false);
            // IE8-
          } else if (ONREADYSTATECHANGE in createElement("script")) {
            defer = function (id) {
              html.appendChild(createElement("script"))[ONREADYSTATECHANGE] =
                function () {
                  html.removeChild(this);
                  run.call(id);
                };
            };
            // Rest old browsers
          } else {
            defer = function (id) {
              setTimeout(bind(run, id, 1), 0);
            };
          }
        }

        module.exports = {
          set: set,
          clear: clear,
        };

        /***/
      },
      /* 46 */
      /***/ function (module, exports, __webpack_require__) {
        var anObject = __webpack_require__(2);
        var isObject = __webpack_require__(5);
        var newPromiseCapability = __webpack_require__(18);

        module.exports = function (C, x) {
          anObject(C);
          if (isObject(x) && x.constructor === C) return x;
          var promiseCapability = newPromiseCapability.f(C);
          var resolve = promiseCapability.resolve;
          resolve(x);
          return promiseCapability.promise;
        };

        /***/
      },
      /* 47 */
      /***/ function (module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true,
        });

        __webpack_require__(48);

        var _promise = __webpack_require__(50);

        var _promise2 = _interopRequireDefault(_promise);

        var _beerslider = __webpack_require__(91);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : { default: obj };
        }

        exports.default = _beerslider.BeerSlider;

        /***/
      },
      /* 48 */
      /***/ function (module, exports, __webpack_require__) {
        // extracted by mini-css-extract-plugin
        /***/
      },
      ,
      /* 49 */ /* 50 */
      /***/ function (module, exports, __webpack_require__) {
        module.exports = __webpack_require__(51);

        __webpack_require__(89);
        __webpack_require__(90);

        /***/
      },
      /* 51 */
      /***/ function (module, exports, __webpack_require__) {
        __webpack_require__(52);
        __webpack_require__(55);
        __webpack_require__(73);
        __webpack_require__(77);
        __webpack_require__(88);

        module.exports = __webpack_require__(29).Promise;

        /***/
      },
      /* 52 */
      /***/ function (module, exports, __webpack_require__) {
        var toString = __webpack_require__(53);

        // `Object.prototype.toString` method
        // https://tc39.github.io/ecma262/#sec-object.prototype.tostring
        if (toString !== {}.toString) {
          __webpack_require__(14)(Object.prototype, "toString", toString, true);
        }

        /***/
      },
      /* 53 */
      /***/ function (module, exports, __webpack_require__) {
        "use strict";

        var classof = __webpack_require__(30);
        var TO_STRING_TAG = __webpack_require__(1)("toStringTag");
        var test = {};

        test[TO_STRING_TAG] = "z";

        // `Object.prototype.toString` method implementation
        // https://tc39.github.io/ecma262/#sec-object.prototype.tostring
        module.exports =
          String(test) !== "[object z]"
            ? function toString() {
                return "[object " + classof(this) + "]";
              }
            : test.toString;

        /***/
      },
      /* 54 */
      /***/ function (module, exports, __webpack_require__) {
        // Chrome 38 Symbol has incorrect toString conversion
        module.exports = !__webpack_require__(12)(function () {
          // eslint-disable-next-line no-undef
          String(Symbol());
        });

        /***/
      },
      /* 55 */
      /***/ function (module, exports, __webpack_require__) {
        "use strict";

        var at = __webpack_require__(56)(true);
        var InternalStateModule = __webpack_require__(15);
        var defineIterator = __webpack_require__(35);
        var STRING_ITERATOR = "String Iterator";
        var setInternalState = InternalStateModule.set;
        var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

        // `String.prototype[@@iterator]` method
        // https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
        defineIterator(
          String,
          "String",
          function (iterated) {
            setInternalState(this, {
              type: STRING_ITERATOR,
              string: String(iterated),
              index: 0,
            });
            // `%StringIteratorPrototype%.next` method
            // https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
          },
          function next() {
            var state = getInternalState(this);
            var string = state.string;
            var index = state.index;
            var point;
            if (index >= string.length) return { value: undefined, done: true };
            point = at(string, index);
            state.index += point.length;
            return { value: point, done: false };
          }
        );

        /***/
      },
      /* 56 */
      /***/ function (module, exports, __webpack_require__) {
        var toInteger = __webpack_require__(24);
        var requireObjectCoercible = __webpack_require__(25);
        // true  -> String#at
        // false -> String#codePointAt
        module.exports = function (TO_STRING) {
          return function (that, pos) {
            var S = String(requireObjectCoercible(that));
            var position = toInteger(pos);
            var size = S.length;
            var first, second;
            if (position < 0 || position >= size)
              return TO_STRING ? "" : undefined;
            first = S.charCodeAt(position);
            return first < 0xd800 ||
              first > 0xdbff ||
              position + 1 === size ||
              (second = S.charCodeAt(position + 1)) < 0xdc00 ||
              second > 0xdfff
              ? TO_STRING
                ? S.charAt(position)
                : first
              : TO_STRING
              ? S.slice(position, position + 2)
              : ((first - 0xd800) << 10) + (second - 0xdc00) + 0x10000;
          };
        };

        /***/
      },
      /* 57 */
      /***/ function (module, exports, __webpack_require__) {
        var has = __webpack_require__(4);
        var ownKeys = __webpack_require__(58);
        var getOwnPropertyDescriptorModule = __webpack_require__(64);
        var definePropertyModule = __webpack_require__(8);

        module.exports = function (target, source) {
          var keys = ownKeys(source);
          var defineProperty = definePropertyModule.f;
          var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            if (!has(target, key))
              defineProperty(
                target,
                key,
                getOwnPropertyDescriptor(source, key)
              );
          }
        };

        /***/
      },
      /* 58 */
      /***/ function (module, exports, __webpack_require__) {
        var getOwnPropertyNamesModule = __webpack_require__(59);
        var getOwnPropertySymbolsModule = __webpack_require__(63);
        var anObject = __webpack_require__(2);
        var Reflect = __webpack_require__(0).Reflect;

        // all object keys, includes non-enumerable and symbols
        module.exports =
          (Reflect && Reflect.ownKeys) ||
          function ownKeys(it) {
            var keys = getOwnPropertyNamesModule.f(anObject(it));
            var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
            return getOwnPropertySymbols
              ? keys.concat(getOwnPropertySymbols(it))
              : keys;
          };

        /***/
      },
      /* 59 */
      /***/ function (module, exports, __webpack_require__) {
        // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
        var internalObjectKeys = __webpack_require__(36);
        var hiddenKeys = __webpack_require__(26).concat("length", "prototype");

        exports.f =
          Object.getOwnPropertyNames ||
          function getOwnPropertyNames(O) {
            return internalObjectKeys(O, hiddenKeys);
          };

        /***/
      },
      /* 60 */
      /***/ function (module, exports, __webpack_require__) {
        // fallback for non-array-like ES3 and non-enumerable old V8 strings
        var classof = __webpack_require__(7);
        var split = "".split;
        // eslint-disable-next-line no-prototype-builtins
        module.exports = Object("z").propertyIsEnumerable(0)
          ? Object
          : function (it) {
              return classof(it) == "String" ? split.call(it, "") : Object(it);
            };

        /***/
      },
      /* 61 */
      /***/ function (module, exports, __webpack_require__) {
        var toIndexedObject = __webpack_require__(16);
        var toLength = __webpack_require__(37);
        var toAbsoluteIndex = __webpack_require__(62);

        // `Array.prototype.{ indexOf, includes }` methods implementation
        // false -> Array#indexOf
        // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
        // true  -> Array#includes
        // https://tc39.github.io/ecma262/#sec-array.prototype.includes
        module.exports = function (IS_INCLUDES) {
          return function ($this, el, fromIndex) {
            var O = toIndexedObject($this);
            var length = toLength(O.length);
            var index = toAbsoluteIndex(fromIndex, length);
            var value;
            // Array#includes uses SameValueZero equality algorithm
            // eslint-disable-next-line no-self-compare
            if (IS_INCLUDES && el != el)
              while (length > index) {
                value = O[index++];
                // eslint-disable-next-line no-self-compare
                if (value != value) return true;
                // Array#indexOf ignores holes, Array#includes - not
              }
            else
              for (; length > index; index++)
                if (IS_INCLUDES || index in O) {
                  if (O[index] === el) return IS_INCLUDES || index || 0;
                }
            return !IS_INCLUDES && -1;
          };
        };

        /***/
      },
      /* 62 */
      /***/ function (module, exports, __webpack_require__) {
        var toInteger = __webpack_require__(24);
        var max = Math.max;
        var min = Math.min;

        // Helper for a popular repeating case of the spec:
        // Let integer be ? ToInteger(index).
        // If integer < 0, let result be max((length + integer), 0); else let result be min(length, length).
        module.exports = function (index, length) {
          var integer = toInteger(index);
          return integer < 0 ? max(integer + length, 0) : min(integer, length);
        };

        /***/
      },
      /* 63 */
      /***/ function (module, exports) {
        exports.f = Object.getOwnPropertySymbols;

        /***/
      },
      /* 64 */
      /***/ function (module, exports, __webpack_require__) {
        var DESCRIPTORS = __webpack_require__(6);
        var propertyIsEnumerableModule = __webpack_require__(65);
        var createPropertyDescriptor = __webpack_require__(21);
        var toIndexedObject = __webpack_require__(16);
        var toPrimitive = __webpack_require__(32);
        var has = __webpack_require__(4);
        var IE8_DOM_DEFINE = __webpack_require__(31);
        var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

        exports.f = DESCRIPTORS
          ? nativeGetOwnPropertyDescriptor
          : function getOwnPropertyDescriptor(O, P) {
              O = toIndexedObject(O);
              P = toPrimitive(P, true);
              if (IE8_DOM_DEFINE)
                try {
                  return nativeGetOwnPropertyDescriptor(O, P);
                } catch (e) {
                  /* empty */
                }
              if (has(O, P))
                return createPropertyDescriptor(
                  !propertyIsEnumerableModule.f.call(O, P),
                  O[P]
                );
            };

        /***/
      },
      /* 65 */
      /***/ function (module, exports, __webpack_require__) {
        "use strict";

        var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
        var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

        // Nashorn ~ JDK8 bug
        var NASHORN_BUG =
          nativeGetOwnPropertyDescriptor &&
          !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

        exports.f = NASHORN_BUG
          ? function propertyIsEnumerable(V) {
              var descriptor = nativeGetOwnPropertyDescriptor(this, V);
              return !!descriptor && descriptor.enumerable;
            }
          : nativePropertyIsEnumerable;

        /***/
      },
      /* 66 */
      /***/ function (module, exports, __webpack_require__) {
        "use strict";

        var IteratorPrototype = __webpack_require__(38).IteratorPrototype;
        var create = __webpack_require__(40);
        var createPropertyDescriptor = __webpack_require__(21);
        var setToStringTag = __webpack_require__(27);
        var Iterators = __webpack_require__(10);

        var returnThis = function () {
          return this;
        };

        module.exports = function (IteratorConstructor, NAME, next) {
          var TO_STRING_TAG = NAME + " Iterator";
          IteratorConstructor.prototype = create(IteratorPrototype, {
            next: createPropertyDescriptor(1, next),
          });
          setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
          Iterators[TO_STRING_TAG] = returnThis;
          return IteratorConstructor;
        };

        /***/
      },
      /* 67 */
      /***/ function (module, exports, __webpack_require__) {
        var requireObjectCoercible = __webpack_require__(25);

        // `ToObject` abstract operation
        // https://tc39.github.io/ecma262/#sec-toobject
        module.exports = function (argument) {
          return Object(requireObjectCoercible(argument));
        };

        /***/
      },
      /* 68 */
      /***/ function (module, exports, __webpack_require__) {
        module.exports = !__webpack_require__(12)(function () {
          function F() {
            /* empty */
          }
          F.prototype.constructor = null;
          return Object.getPrototypeOf(new F()) !== F.prototype;
        });

        /***/
      },
      /* 69 */
      /***/ function (module, exports, __webpack_require__) {
        var DESCRIPTORS = __webpack_require__(6);
        var definePropertyModule = __webpack_require__(8);
        var anObject = __webpack_require__(2);
        var objectKeys = __webpack_require__(70);

        module.exports = DESCRIPTORS
          ? Object.defineProperties
          : function defineProperties(O, Properties) {
              anObject(O);
              var keys = objectKeys(Properties);
              var length = keys.length;
              var i = 0;
              var key;
              while (length > i)
                definePropertyModule.f(O, (key = keys[i++]), Properties[key]);
              return O;
            };

        /***/
      },
      /* 70 */
      /***/ function (module, exports, __webpack_require__) {
        // 19.1.2.14 / 15.2.3.14 Object.keys(O)
        var internalObjectKeys = __webpack_require__(36);
        var enumBugKeys = __webpack_require__(26);

        module.exports =
          Object.keys ||
          function keys(O) {
            return internalObjectKeys(O, enumBugKeys);
          };

        /***/
      },
      /* 71 */
      /***/ function (module, exports, __webpack_require__) {
        // Works with __proto__ only. Old v8 can't work with null proto objects.
        /* eslint-disable no-proto */
        var validateSetPrototypeOfArguments = __webpack_require__(72);

        module.exports =
          Object.setPrototypeOf ||
          ("__proto__" in {}
            ? (function () {
                // eslint-disable-line
                var test = {};
                var correctSetter = true;
                var setter;
                try {
                  setter = Object.getOwnPropertyDescriptor(
                    Object.prototype,
                    "__proto__"
                  ).set;
                  setter.call(test, []);
                  correctSetter = test instanceof Array;
                } catch (e) {
                  correctSetter = false;
                }
                return function setPrototypeOf(O, proto) {
                  validateSetPrototypeOfArguments(O, proto);
                  if (correctSetter) setter.call(O, proto);
                  else O.__proto__ = proto;
                  return O;
                };
              })()
            : undefined);

        /***/
      },
      /* 72 */
      /***/ function (module, exports, __webpack_require__) {
        var isObject = __webpack_require__(5);
        var anObject = __webpack_require__(2);

        module.exports = function (O, proto) {
          anObject(O);
          if (!isObject(proto) && proto !== null)
            throw TypeError(String(proto) + ": can't set as a prototype!");
        };

        /***/
      },
      /* 73 */
      /***/ function (module, exports, __webpack_require__) {
        var DOMIterables = __webpack_require__(74);
        var ArrayIteratorMethods = __webpack_require__(75);
        var global = __webpack_require__(0);
        var hide = __webpack_require__(3);
        var wellKnownSymbol = __webpack_require__(1);
        var ITERATOR = wellKnownSymbol("iterator");
        var TO_STRING_TAG = wellKnownSymbol("toStringTag");
        var ArrayValues = ArrayIteratorMethods.values;

        for (var COLLECTION_NAME in DOMIterables) {
          var Collection = global[COLLECTION_NAME];
          var CollectionPrototype = Collection && Collection.prototype;
          if (CollectionPrototype) {
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[ITERATOR] !== ArrayValues)
              try {
                hide(CollectionPrototype, ITERATOR, ArrayValues);
              } catch (e) {
                CollectionPrototype[ITERATOR] = ArrayValues;
              }
            if (!CollectionPrototype[TO_STRING_TAG])
              hide(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
            if (DOMIterables[COLLECTION_NAME])
              for (var METHOD_NAME in ArrayIteratorMethods) {
                // some Chrome versions have non-configurable methods on DOMTokenList
                if (
                  CollectionPrototype[METHOD_NAME] !==
                  ArrayIteratorMethods[METHOD_NAME]
                )
                  try {
                    hide(
                      CollectionPrototype,
                      METHOD_NAME,
                      ArrayIteratorMethods[METHOD_NAME]
                    );
                  } catch (e) {
                    CollectionPrototype[METHOD_NAME] =
                      ArrayIteratorMethods[METHOD_NAME];
                  }
              }
          }
        }

        /***/
      },
      /* 74 */
      /***/ function (module, exports) {
        // iterable DOM collections
        // flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
        module.exports = {
          CSSRuleList: 0,
          CSSStyleDeclaration: 0,
          CSSValueList: 0,
          ClientRectList: 0,
          DOMRectList: 0,
          DOMStringList: 0,
          DOMTokenList: 1,
          DataTransferItemList: 0,
          FileList: 0,
          HTMLAllCollection: 0,
          HTMLCollection: 0,
          HTMLFormElement: 0,
          HTMLSelectElement: 0,
          MediaList: 0,
          MimeTypeArray: 0,
          NamedNodeMap: 0,
          NodeList: 1,
          PaintRequestList: 0,
          Plugin: 0,
          PluginArray: 0,
          SVGLengthList: 0,
          SVGNumberList: 0,
          SVGPathSegList: 0,
          SVGPointList: 0,
          SVGStringList: 0,
          SVGTransformList: 0,
          SourceBufferList: 0,
          StyleSheetList: 0,
          TextTrackCueList: 0,
          TextTrackList: 0,
          TouchList: 0,
        };

        /***/
      },
      /* 75 */
      /***/ function (module, exports, __webpack_require__) {
        "use strict";

        var toIndexedObject = __webpack_require__(16);
        var addToUnscopables = __webpack_require__(76);
        var Iterators = __webpack_require__(10);
        var InternalStateModule = __webpack_require__(15);
        var defineIterator = __webpack_require__(35);
        var ARRAY_ITERATOR = "Array Iterator";
        var setInternalState = InternalStateModule.set;
        var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

        // `Array.prototype.entries` method
        // https://tc39.github.io/ecma262/#sec-array.prototype.entries
        // `Array.prototype.keys` method
        // https://tc39.github.io/ecma262/#sec-array.prototype.keys
        // `Array.prototype.values` method
        // https://tc39.github.io/ecma262/#sec-array.prototype.values
        // `Array.prototype[@@iterator]` method
        // https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
        // `CreateArrayIterator` internal method
        // https://tc39.github.io/ecma262/#sec-createarrayiterator
        module.exports = defineIterator(
          Array,
          "Array",
          function (iterated, kind) {
            setInternalState(this, {
              type: ARRAY_ITERATOR,
              target: toIndexedObject(iterated), // target
              index: 0, // next index
              kind: kind, // kind
            });
            // `%ArrayIteratorPrototype%.next` method
            // https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
          },
          function () {
            var state = getInternalState(this);
            var target = state.target;
            var kind = state.kind;
            var index = state.index++;
            if (!target || index >= target.length) {
              state.target = undefined;
              return { value: undefined, done: true };
            }
            if (kind == "keys") return { value: index, done: false };
            if (kind == "values") return { value: target[index], done: false };
            return { value: [index, target[index]], done: false };
          },
          "values"
        );

        // argumentsList[@@iterator] is %ArrayProto_values%
        // https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
        // https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
        Iterators.Arguments = Iterators.Array;

        // https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
        addToUnscopables("keys");
        addToUnscopables("values");
        addToUnscopables("entries");

        /***/
      },
      /* 76 */
      /***/ function (module, exports, __webpack_require__) {
        var UNSCOPABLES = __webpack_require__(1)("unscopables");
        var create = __webpack_require__(40);
        var hide = __webpack_require__(3);
        var ArrayPrototype = Array.prototype;

        // Array.prototype[@@unscopables]
        // https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
        if (ArrayPrototype[UNSCOPABLES] == undefined)
          hide(ArrayPrototype, UNSCOPABLES, create(null));

        // add a key to Array.prototype[@@unscopables]
        module.exports = function (key) {
          ArrayPrototype[UNSCOPABLES][key] = true;
        };

        /***/
      },
      /* 77 */
      /***/ function (module, exports, __webpack_require__) {
        "use strict";

        var PROMISE = "Promise";
        var IS_PURE = __webpack_require__(13);
        var global = __webpack_require__(0);
        var $export = __webpack_require__(9);
        var isObject = __webpack_require__(5);
        var aFunction = __webpack_require__(17);
        var anInstance = __webpack_require__(78);
        var classof = __webpack_require__(7);
        var iterate = __webpack_require__(42);
        var checkCorrectnessOfIteration = __webpack_require__(82);
        var speciesConstructor = __webpack_require__(44);
        var task = __webpack_require__(45).set;
        var microtask = __webpack_require__(83)();
        var promiseResolve = __webpack_require__(46);
        var hostReportErrors = __webpack_require__(84);
        var newPromiseCapabilityModule = __webpack_require__(18);
        var perform = __webpack_require__(28);
        var userAgent = __webpack_require__(85);
        var SPECIES = __webpack_require__(1)("species");
        var InternalStateModule = __webpack_require__(15);
        var getInternalState = InternalStateModule.get;
        var setInternalState = InternalStateModule.set;
        var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
        var PromiseConstructor = global[PROMISE];
        var TypeError = global.TypeError;
        var document = global.document;
        var process = global.process;
        var versions = process && process.versions;
        var v8 = (versions && versions.v8) || "";
        var newPromiseCapability = newPromiseCapabilityModule.f;
        var newGenericPromiseCapability = newPromiseCapability;
        var IS_NODE = classof(process) == "process";
        var DISPATCH_EVENT = !!(
          document &&
          document.createEvent &&
          global.dispatchEvent
        );
        var UNHANDLED_REJECTION = "unhandledrejection";
        var REJECTION_HANDLED = "rejectionhandled";
        var PENDING = 0;
        var FULFILLED = 1;
        var REJECTED = 2;
        var HANDLED = 1;
        var UNHANDLED = 2;
        var Internal, OwnPromiseCapability, PromiseWrapper;

        var USE_NATIVE = !!(function () {
          try {
            // correct subclassing with @@species support
            var promise = PromiseConstructor.resolve(1);
            var empty = function () {
              /* empty */
            };
            var FakePromise = ((promise.constructor = {})[SPECIES] = function (
              exec
            ) {
              exec(empty, empty);
            });
            // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
            return (
              (IS_NODE || typeof PromiseRejectionEvent == "function") &&
              (!IS_PURE || promise["finally"]) &&
              promise.then(empty) instanceof FakePromise &&
              // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
              // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
              // we can't detect it synchronously, so just check versions
              v8.indexOf("6.6") !== 0 &&
              userAgent.indexOf("Chrome/66") === -1
            );
          } catch (e) {
            /* empty */
          }
        })();

        // helpers
        var isThenable = function (it) {
          var then;
          return isObject(it) && typeof (then = it.then) == "function"
            ? then
            : false;
        };

        var notify = function (promise, state, isReject) {
          if (state.notified) return;
          state.notified = true;
          var chain = state.reactions;
          microtask(function () {
            var value = state.value;
            var ok = state.state == FULFILLED;
            var i = 0;
            var run = function (reaction) {
              var handler = ok ? reaction.ok : reaction.fail;
              var resolve = reaction.resolve;
              var reject = reaction.reject;
              var domain = reaction.domain;
              var result, then, exited;
              try {
                if (handler) {
                  if (!ok) {
                    if (state.rejection === UNHANDLED)
                      onHandleUnhandled(promise, state);
                    state.rejection = HANDLED;
                  }
                  if (handler === true) result = value;
                  else {
                    if (domain) domain.enter();
                    result = handler(value); // may throw
                    if (domain) {
                      domain.exit();
                      exited = true;
                    }
                  }
                  if (result === reaction.promise) {
                    reject(TypeError("Promise-chain cycle"));
                  } else if ((then = isThenable(result))) {
                    then.call(result, resolve, reject);
                  } else resolve(result);
                } else reject(value);
              } catch (e) {
                if (domain && !exited) domain.exit();
                reject(e);
              }
            };
            while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
            state.reactions = [];
            state.notified = false;
            if (isReject && !state.rejection) onUnhandled(promise, state);
          });
        };

        var dispatchEvent = function (name, promise, reason) {
          var event, handler;
          if (DISPATCH_EVENT) {
            event = document.createEvent("Event");
            event.promise = promise;
            event.reason = reason;
            event.initEvent(name, false, true);
            global.dispatchEvent(event);
          } else event = { promise: promise, reason: reason };
          if ((handler = global["on" + name])) handler(event);
          else if (name === UNHANDLED_REJECTION)
            hostReportErrors("Unhandled promise rejection", reason);
        };

        var onUnhandled = function (promise, state) {
          task.call(global, function () {
            var value = state.value;
            var IS_UNHANDLED = isUnhandled(state);
            var result;
            if (IS_UNHANDLED) {
              result = perform(function () {
                if (IS_NODE) {
                  process.emit("unhandledRejection", value, promise);
                } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
              });
              // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
              state.rejection =
                IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
            }
            if (IS_UNHANDLED && result.e) throw result.v;
          });
        };

        var isUnhandled = function (state) {
          return state.rejection !== HANDLED && !state.parent;
        };

        var onHandleUnhandled = function (promise, state) {
          task.call(global, function () {
            if (IS_NODE) {
              process.emit("rejectionHandled", promise);
            } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
          });
        };

        var bind = function (fn, promise, state, unwrap) {
          return function (value) {
            fn(promise, state, value, unwrap);
          };
        };

        var internalReject = function (promise, state, value, unwrap) {
          if (state.done) return;
          state.done = true;
          if (unwrap) state = unwrap;
          state.value = value;
          state.state = REJECTED;
          notify(promise, state, true);
        };

        var internalResolve = function (promise, state, value, unwrap) {
          if (state.done) return;
          state.done = true;
          if (unwrap) state = unwrap;
          try {
            if (promise === value)
              throw TypeError("Promise can't be resolved itself!");
            var then = isThenable(value);
            if (then) {
              microtask(function () {
                var wrapper = { done: false };
                try {
                  then.call(
                    value,
                    bind(internalResolve, promise, wrapper, state),
                    bind(internalReject, promise, wrapper, state)
                  );
                } catch (e) {
                  internalReject(promise, wrapper, e, state);
                }
              });
            } else {
              state.value = value;
              state.state = FULFILLED;
              notify(promise, state, false);
            }
          } catch (e) {
            internalReject(promise, { done: false }, e, state);
          }
        };

        // constructor polyfill
        if (!USE_NATIVE) {
          // 25.4.3.1 Promise(executor)
          PromiseConstructor = function Promise(executor) {
            anInstance(this, PromiseConstructor, PROMISE);
            aFunction(executor);
            Internal.call(this);
            var state = getInternalState(this);
            try {
              executor(
                bind(internalResolve, this, state),
                bind(internalReject, this, state)
              );
            } catch (err) {
              internalReject(this, state, err);
            }
          };
          // eslint-disable-next-line no-unused-vars
          Internal = function Promise(executor) {
            setInternalState(this, {
              type: PROMISE,
              done: false,
              notified: false,
              parent: false,
              reactions: [],
              rejection: false,
              state: PENDING,
              value: undefined,
            });
          };
          Internal.prototype = __webpack_require__(86)(
            PromiseConstructor.prototype,
            {
              // `Promise.prototype.then` method
              // https://tc39.github.io/ecma262/#sec-promise.prototype.then
              then: function then(onFulfilled, onRejected) {
                var state = getInternalPromiseState(this);
                var reaction = newPromiseCapability(
                  speciesConstructor(this, PromiseConstructor)
                );
                reaction.ok =
                  typeof onFulfilled == "function" ? onFulfilled : true;
                reaction.fail = typeof onRejected == "function" && onRejected;
                reaction.domain = IS_NODE ? process.domain : undefined;
                state.parent = true;
                state.reactions.push(reaction);
                if (state.state != PENDING) notify(this, state, false);
                return reaction.promise;
              },
              // `Promise.prototype.catch` method
              // https://tc39.github.io/ecma262/#sec-promise.prototype.catch
              catch: function (onRejected) {
                return this.then(undefined, onRejected);
              },
            }
          );
          OwnPromiseCapability = function () {
            var promise = new Internal();
            var state = getInternalState(promise);
            this.promise = promise;
            this.resolve = bind(internalResolve, promise, state);
            this.reject = bind(internalReject, promise, state);
          };
          newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
            return C === PromiseConstructor || C === PromiseWrapper
              ? new OwnPromiseCapability(C)
              : newGenericPromiseCapability(C);
          };
        }

        $export(
          { global: true, wrap: true, forced: !USE_NATIVE },
          { Promise: PromiseConstructor }
        );

        __webpack_require__(27)(PromiseConstructor, PROMISE, false, true);
        __webpack_require__(87)(PROMISE);

        PromiseWrapper = __webpack_require__(29)[PROMISE];

        // statics
        $export(
          { target: PROMISE, stat: true, forced: !USE_NATIVE },
          {
            // `Promise.reject` method
            // https://tc39.github.io/ecma262/#sec-promise.reject
            reject: function reject(r) {
              var capability = newPromiseCapability(this);
              capability.reject.call(undefined, r);
              return capability.promise;
            },
          }
        );

        $export(
          { target: PROMISE, stat: true, forced: IS_PURE || !USE_NATIVE },
          {
            // `Promise.resolve` method
            // https://tc39.github.io/ecma262/#sec-promise.resolve
            resolve: function resolve(x) {
              return promiseResolve(
                IS_PURE && this === PromiseWrapper ? PromiseConstructor : this,
                x
              );
            },
          }
        );

        $export(
          {
            target: PROMISE,
            stat: true,
            forced: !(
              USE_NATIVE &&
              checkCorrectnessOfIteration(function (iterable) {
                PromiseConstructor.all(iterable)["catch"](function () {
                  /* empty */
                });
              })
            ),
          },
          {
            // `Promise.all` method
            // https://tc39.github.io/ecma262/#sec-promise.all
            all: function all(iterable) {
              var C = this;
              var capability = newPromiseCapability(C);
              var resolve = capability.resolve;
              var reject = capability.reject;
              var result = perform(function () {
                var values = [];
                var counter = 0;
                var remaining = 1;
                iterate(iterable, function (promise) {
                  var index = counter++;
                  var alreadyCalled = false;
                  values.push(undefined);
                  remaining++;
                  C.resolve(promise).then(function (value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = value;
                    --remaining || resolve(values);
                  }, reject);
                });
                --remaining || resolve(values);
              });
              if (result.e) reject(result.v);
              return capability.promise;
            },
            // `Promise.race` method
            // https://tc39.github.io/ecma262/#sec-promise.race
            race: function race(iterable) {
              var C = this;
              var capability = newPromiseCapability(C);
              var reject = capability.reject;
              var result = perform(function () {
                iterate(iterable, function (promise) {
                  C.resolve(promise).then(capability.resolve, reject);
                });
              });
              if (result.e) reject(result.v);
              return capability.promise;
            },
          }
        );

        /***/
      },
      /* 78 */
      /***/ function (module, exports) {
        module.exports = function (it, Constructor, name) {
          if (!(it instanceof Constructor)) {
            throw TypeError(
              (name ? name + ": i" : "I") + "ncorrect invocation!"
            );
          }
          return it;
        };

        /***/
      },
      /* 79 */
      /***/ function (module, exports, __webpack_require__) {
        // check on default Array iterator
        var Iterators = __webpack_require__(10);
        var ITERATOR = __webpack_require__(1)("iterator");
        var ArrayPrototype = Array.prototype;

        module.exports = function (it) {
          return (
            it !== undefined &&
            (Iterators.Array === it || ArrayPrototype[ITERATOR] === it)
          );
        };

        /***/
      },
      /* 80 */
      /***/ function (module, exports, __webpack_require__) {
        var classof = __webpack_require__(30);
        var ITERATOR = __webpack_require__(1)("iterator");
        var Iterators = __webpack_require__(10);

        module.exports = function (it) {
          if (it != undefined)
            return it[ITERATOR] || it["@@iterator"] || Iterators[classof(it)];
        };

        /***/
      },
      /* 81 */
      /***/ function (module, exports, __webpack_require__) {
        var anObject = __webpack_require__(2);

        // call something on iterator step with safe closing on error
        module.exports = function (iterator, fn, value, ENTRIES) {
          try {
            return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
            // 7.4.6 IteratorClose(iterator, completion)
          } catch (e) {
            var returnMethod = iterator["return"];
            if (returnMethod !== undefined)
              anObject(returnMethod.call(iterator));
            throw e;
          }
        };

        /***/
      },
      /* 82 */
      /***/ function (module, exports, __webpack_require__) {
        var ITERATOR = __webpack_require__(1)("iterator");
        var SAFE_CLOSING = false;

        try {
          var called = 0;
          var iteratorWithReturn = {
            next: function () {
              return { done: !!called++ };
            },
            return: function () {
              SAFE_CLOSING = true;
            },
          };
          iteratorWithReturn[ITERATOR] = function () {
            return this;
          };
          // eslint-disable-next-line no-throw-literal
          Array.from(iteratorWithReturn, function () {
            throw 2;
          });
        } catch (e) {
          /* empty */
        }

        module.exports = function (exec, SKIP_CLOSING) {
          if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
          var ITERATION_SUPPORT = false;
          try {
            var object = {};
            object[ITERATOR] = function () {
              return {
                next: function () {
                  return { done: (ITERATION_SUPPORT = true) };
                },
              };
            };
            exec(object);
          } catch (e) {
            /* empty */
          }
          return ITERATION_SUPPORT;
        };

        /***/
      },
      /* 83 */
      /***/ function (module, exports, __webpack_require__) {
        var global = __webpack_require__(0);
        var classof = __webpack_require__(7);
        var macrotask = __webpack_require__(45).set;
        var Observer = global.MutationObserver || global.WebKitMutationObserver;
        var process = global.process;
        var Promise = global.Promise;
        var isNode = classof(process) == "process";

        module.exports = function () {
          var head, last, notify;

          var flush = function () {
            var parent, fn;
            if (isNode && (parent = process.domain)) parent.exit();
            while (head) {
              fn = head.fn;
              head = head.next;
              try {
                fn();
              } catch (e) {
                if (head) notify();
                else last = undefined;
                throw e;
              }
            }
            last = undefined;
            if (parent) parent.enter();
          };

          // Node.js
          if (isNode) {
            notify = function () {
              process.nextTick(flush);
            };
            // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
          } else if (
            Observer &&
            !(global.navigator && global.navigator.standalone)
          ) {
            var toggle = true;
            var node = document.createTextNode("");
            new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
            notify = function () {
              node.data = toggle = !toggle;
            };
            // environments with maybe non-completely correct, but existent Promise
          } else if (Promise && Promise.resolve) {
            // Promise.resolve without an argument throws an error in LG WebOS 2
            var promise = Promise.resolve(undefined);
            notify = function () {
              promise.then(flush);
            };
            // for other environments - macrotask based on:
            // - setImmediate
            // - MessageChannel
            // - window.postMessag
            // - onreadystatechange
            // - setTimeout
          } else {
            notify = function () {
              // strange IE + webpack dev server bug - use .call(global)
              macrotask.call(global, flush);
            };
          }

          return function (fn) {
            var task = { fn: fn, next: undefined };
            if (last) last.next = task;
            if (!head) {
              head = task;
              notify();
            }
            last = task;
          };
        };

        /***/
      },
      /* 84 */
      /***/ function (module, exports, __webpack_require__) {
        var global = __webpack_require__(0);

        module.exports = function (a, b) {
          var console = global.console;
          if (console && console.error) {
            arguments.length === 1 ? console.error(a) : console.error(a, b);
          }
        };

        /***/
      },
      /* 85 */
      /***/ function (module, exports, __webpack_require__) {
        var global = __webpack_require__(0);
        var navigator = global.navigator;

        module.exports = (navigator && navigator.userAgent) || "";

        /***/
      },
      /* 86 */
      /***/ function (module, exports, __webpack_require__) {
        var redefine = __webpack_require__(14);

        module.exports = function (target, src, safe) {
          for (var key in src) redefine(target, key, src[key], safe);
          return target;
        };

        /***/
      },
      /* 87 */
      /***/ function (module, exports, __webpack_require__) {
        "use strict";

        var global = __webpack_require__(0);
        var definePropertyModule = __webpack_require__(8);
        var DESCRIPTORS = __webpack_require__(6);
        var SPECIES = __webpack_require__(1)("species");

        module.exports = function (KEY) {
          var C = global[KEY];
          if (DESCRIPTORS && C && !C[SPECIES])
            definePropertyModule.f(C, SPECIES, {
              configurable: true,
              get: function () {
                return this;
              },
            });
        };

        /***/
      },
      /* 88 */
      /***/ function (module, exports, __webpack_require__) {
        "use strict";

        var path = __webpack_require__(29);
        var global = __webpack_require__(0);
        var speciesConstructor = __webpack_require__(44);
        var promiseResolve = __webpack_require__(46);

        // `Promise.prototype.finally` method
        // https://tc39.github.io/ecma262/#sec-promise.prototype.finally
        __webpack_require__(9)(
          { target: "Promise", proto: true, real: true },
          {
            finally: function (onFinally) {
              var C = speciesConstructor(
                this,
                typeof path.Promise == "function"
                  ? path.Promise
                  : global.Promise
              );
              var isFunction = typeof onFinally == "function";
              return this.then(
                isFunction
                  ? function (x) {
                      return promiseResolve(C, onFinally()).then(function () {
                        return x;
                      });
                    }
                  : onFinally,
                isFunction
                  ? function (e) {
                      return promiseResolve(C, onFinally()).then(function () {
                        throw e;
                      });
                    }
                  : onFinally
              );
            },
          }
        );

        /***/
      },
      /* 89 */
      /***/ function (module, exports, __webpack_require__) {
        "use strict";

        // `Promise.allSettled` method
        // https://github.com/jasonwilliams/proposal-promise-allSettled
        var newPromiseCapabilityModule = __webpack_require__(18);
        var perform = __webpack_require__(28);
        var iterate = __webpack_require__(42);

        __webpack_require__(9)(
          { target: "Promise", stat: true },
          {
            allSettled: function allSettled(iterable) {
              var C = this;
              var capability = newPromiseCapabilityModule.f(C);
              var resolve = capability.resolve;
              var reject = capability.reject;
              var result = perform(function () {
                var values = [];
                var counter = 0;
                var remaining = 1;
                iterate(iterable, function (promise) {
                  var index = counter++;
                  var alreadyCalled = false;
                  values.push(undefined);
                  remaining++;
                  C.resolve(promise).then(
                    function (value) {
                      if (alreadyCalled) return;
                      alreadyCalled = true;
                      values[index] = { value: value, status: "fulfilled" };
                      --remaining || resolve(values);
                    },
                    function (e) {
                      if (alreadyCalled) return;
                      alreadyCalled = true;
                      values[index] = { reason: e, status: "rejected" };
                      --remaining || resolve(values);
                    }
                  );
                });
                --remaining || resolve(values);
              });
              if (result.e) reject(result.v);
              return capability.promise;
            },
          }
        );

        /***/
      },
      /* 90 */
      /***/ function (module, exports, __webpack_require__) {
        "use strict";

        // `Promise.try` method
        // https://github.com/tc39/proposal-promise-try
        var newPromiseCapabilityModule = __webpack_require__(18);
        var perform = __webpack_require__(28);

        __webpack_require__(9)(
          { target: "Promise", stat: true },
          {
            try: function (callbackfn) {
              var promiseCapability = newPromiseCapabilityModule.f(this);
              var result = perform(callbackfn);
              (result.e ? promiseCapability.reject : promiseCapability.resolve)(
                result.v
              );
              return promiseCapability.promise;
            },
          }
        );

        /***/
      },
      /* 91 */
      /***/ function (module, exports, __webpack_require__) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: true,
        });

        var _createClass = (function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }
          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        })();

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        var BeerSlider = (exports.BeerSlider = (function () {
          function BeerSlider(element) {
            var _ref =
                arguments.length > 1 && arguments[1] !== undefined
                  ? arguments[1]
                  : {},
              _ref$start = _ref.start,
              start = _ref$start === undefined ? "50" : _ref$start,
              _ref$prefix = _ref.prefix,
              prefix = _ref$prefix === undefined ? "beer" : _ref$prefix;

            _classCallCheck(this, BeerSlider);

            this.start = parseInt(start)
              ? Math.min(100, Math.max(0, parseInt(start)))
              : 50;
            this.prefix = prefix;
            if (!element || element.children.length !== 2) {
              return;
            }
            this.element = element;
            this.revealContainer = this.element.children[1];
            if (this.revealContainer.children.length < 1) {
              return;
            }
            this.revealElement = this.revealContainer.children[0];
            this.range = this.addElement("input", {
              type: "range",
              class: this.prefix + "-range",
              "aria-label": "Percent of revealed content",
              "aria-valuemin": "0",
              "aria-valuemax": "100",
              "aria-valuenow": this.start,
              value: this.start,
              min: "0",
              max: "100",
            });
            this.handle = this.addElement("span", {
              class: this.prefix + "-handle",
            });
            this.onImagesLoad();
          }

          _createClass(BeerSlider, [
            {
              key: "init",
              value: function init() {
                this.element.classList.add(this.prefix + "-ready");
                this.setImgWidth();
                this.move();
                this.addListeners();
              },
            },
            {
              key: "loadingImg",
              value: function loadingImg(src) {
                return new Promise(function (resolve, reject) {
                  if (!src) {
                    resolve();
                  }
                  var img = new Image();
                  img.onload = function () {
                    return resolve();
                  };
                  img.onerror = function () {
                    return reject();
                  };
                  img.src = src;
                });
              },
            },
            {
              key: "loadedBoth",
              value: function loadedBoth() {
                var mainImageSrc =
                  this.element.children[0].src ||
                  this.element.children[0].getAttribute(
                    "data-" + this.prefix + "-src"
                  );
                var revealImageSrc =
                  this.revealElement.src ||
                  this.revealElement.getAttribute(
                    "data-" + this.prefix + "-src"
                  );
                return Promise.all([
                  this.loadingImg(mainImageSrc),
                  this.loadingImg(revealImageSrc),
                ]);
              },
            },
            {
              key: "onImagesLoad",
              value: function onImagesLoad() {
                var _this = this;

                if (!this.revealElement) {
                  return;
                }
                this.loadedBoth().then(
                  function () {
                    _this.init();
                  },
                  function () {
                    console.error(
                      "Some errors occurred and images are not loaded."
                    );
                  }
                );
              },
            },
            {
              key: "addElement",
              value: function addElement(tag, attributes) {
                var el = document.createElement(tag);
                Object.keys(attributes).forEach(function (key) {
                  el.setAttribute(key, attributes[key]);
                });
                this.element.appendChild(el);
                return el;
              },
            },
            {
              key: "setImgWidth",
              value: function setImgWidth() {
                this.revealElement.style.width = getComputedStyle(this.element)[
                  "width"
                ];
              },
            },
            {
              key: "addListeners",
              value: function addListeners() {
                var _this2 = this;

                var eventTypes = ["input", "change"];
                eventTypes.forEach(function (i) {
                  _this2.range.addEventListener(i, function () {
                    _this2.move();
                  });
                });
                window.addEventListener("resize", function () {
                  _this2.setImgWidth();
                });
              },
            },
            {
              key: "move",
              value: function move() {
                this.revealContainer.style.width = this.range.value + "%";
                this.handle.style.left = this.range.value + "%";
                this.range.setAttribute("aria-valuenow", this.range.value);
              },
            },
          ]);

          return BeerSlider;
        })());

        /***/
      },
      /******/
    ]
  )["default"];
});
